import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/analytics/explain");

export const Route = createFileRoute("/analytics/explain")({
  head: () => ({
    meta: [
      { title: "Explain — LevelLoad" },
      { name: "description", content: "Explain — LevelLoad transport planning." },
      { property: "og:title", content: "Explain — LevelLoad" },
      { property: "og:description", content: "Explain — LevelLoad transport planning." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
